var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBridge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1172_813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2644 20.6246H29.8861C29.2555 17.8652 27.796 15.415 25.7399 13.6638C23.6837 11.9128 21.1489 10.9615 18.5391 10.9615H15.4691C12.8594 10.9615 10.3246 11.9128 8.2684 13.6638C6.2122 15.4149 4.7526 17.8653 4.1222 20.6246H0.743896V9.7468L2.83 8.8266C7.3408 6.8765 12.1493 5.875 17.0021 5.875C21.8549 5.875 26.6637 6.8765 31.1741 8.8266L33.2603 9.7468L33.2644 20.6246Z",
    fill: "#353E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2644 7.87511L31.7864 7.24481C27.0782 5.20971 22.0586 4.16451 16.9935 4.16451C11.9285 4.16451 6.90895 5.20971 2.20075 7.24481L0.748047 7.87521V4.79241L2.83415 3.87211C7.34495 1.92211 12.1534 0.92041 17.0062 0.92041C21.859 0.92041 26.6675 1.92191 31.1783 3.87191L33.2644 4.79221V7.87511Z",
    fill: "#353E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172_813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBridge);
export default __webpack_public_path__ + "static/media/arrow_bridge.b9f559d225d6e4f73d6bb9482e30e8b6.svg";
export { ForwardRef as ReactComponent };